import { FileState } from 'sos-common/js/commonTypes/fileupload.types';
import { FormFieldFile } from 'sos-common/js/commonTypes/formField.types';

export enum FileValidation {
  amountOfFilesExceeded,
  individualFileSizeExceeded,
  isRequiredWithZeroFiles,
  valid,
}

export function validateFiles(
  fileuploadState: FormFieldFile,
  maxAmountOfFiles: number,
  maxIndividualSizeOfFileInBytes: number,
  isRequired: boolean
) {
  const files = fileuploadState.value;

  if (files.length === 0 && isRequired) return FileValidation.isRequiredWithZeroFiles;
  if (files.length > maxAmountOfFiles) return FileValidation.amountOfFilesExceeded;

  let hasIndividualFileSizeExceeded = false;
  files.forEach((fileDetail) => {
    console.log(JSON.stringify(fileDetail));
    if (fileDetail.file.size > maxIndividualSizeOfFileInBytes) {
      fileDetail.status = FileState.INVALID;
      hasIndividualFileSizeExceeded = true;
    }
  });

  if (hasIndividualFileSizeExceeded) return FileValidation.individualFileSizeExceeded;

  return FileValidation.valid;
}
